import { Partner } from 'src/api/@generated/backend-api';

class PartnerUtils {
  public static getPartnerById(partners: Partner[], id: string): Partner | undefined {
    return partners.find((partner) => partner.id === `${id}`);
  }
}

export { PartnerUtils };
